import fetchWithOptions from '../../../shared/utils/fetch';
import {
  Abnormality,
  Definition,
  ServerAnnotatorComment,
  ServerDefinition,
} from '../types/diagnostic';

export const getDefinitions = async (): Promise<Definition[] | null> => {
  try {
    const response = await fetchWithOptions<ServerDefinition[]>(
      '/api/abnormality/v2',
    );
    return parseCategories(response);
  } catch {
    return null;
  }
};

const parseCategories = (tree: ServerDefinition[]): Definition[] => {
  const definitions: Definition[] = [];

  tree.forEach((category) => {
    category['abnormalities'].forEach((abnormality) => {
      definitions.push({
        category: category['category_code'],
        code: abnormality['code'],
        name: abnormality['name'],
        likelihood: abnormality['likelihood'],
        frequency: abnormality['frequency'],
        temporality: abnormality['temporality'],
        localization: abnormality['localization'],
      });
    });
    category['categories'].forEach((subcategory) => {
      subcategory['abnormalities'].forEach((abnormality) => {
        definitions.push({
          category: category['category_code'],
          code: abnormality['code'],
          name: abnormality['name'],
          subcategory: subcategory['category_code'],
          likelihood: abnormality['likelihood'],
          frequency: abnormality['frequency'],
          temporality: abnormality['temporality'],
          localization: abnormality['localization'],
        });
      });
    });
  });

  return definitions;
};

export const saveDiagnostic = async (
  ecgId: string,
  comment: string,
  abnormalities: Abnormality[],
  annotatorComment: ServerAnnotatorComment = {},
): Promise<boolean> => {
  try {
    await fetchWithOptions(`/api/ecg/${ecgId}/diagnosis/v2`, {
      method: 'POST',
      body: JSON.stringify({
        comment,
        abnormalities,
        report_parameters: {
          annotator_comment: annotatorComment,
        },
      }),
    });
    return true;
  } catch {
    return false;
  }
};
